<template>
  <nav :class="classModifiers">
    <div class="app-bottom-nav__menu">
      <div
        v-for="item in enabledLinks"
        :class="itemClassModifier(item)"
        @click="onLinkClick(item.href)"
      >
        <router-link
          v-if="showRegularItem(item)"
          :id="`nav-${item.name}`"
          :class="linkClassModifiers(item.name)"
          :to="item.href"
        >
          {{ item.title.toString() }}
        </router-link>
        <div v-if="showSocialAvatarOnMobile(item)" @click.stop="onAvatarClick">
          &nbsp;
          <account-social-avatar
            theme="nav-bottom"
            :avatar="userAvatar"
            :showProgress="true"
            :percentage="100"
            :progressStrokeColor="levelColorWithRespectToNav"
            :showEdit="false"
          >
            <template v-slot:label>
              <span @click.stop="onAvatarClick">Dashboard</span>
            </template>
          </account-social-avatar>
        </div>
      </div>
    </div>
  </nav>
</template>

<script src="./app-bottom-nav.js"></script>
<style src="./app-bottom-nav.scss" lang="scss"></style>
